import { render } from "./Forget.vue?vue&type=template&id=82ad03be"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=82ad03be&lang=css"

import exportComponent from "/home/ubuntu/apps/synergy-login/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__